/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs */

const en_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI weaves this into captions and chapters. Never appears as its own page.`)
};

const es_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA incorpora esto en los subtítulos y capítulos. Nunca aparece como su propia página.`)
};

const fr_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA intègre cela dans les légendes et chapitres. N'apparaît jamais sur sa propre page.`)
};

const de_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI verwebt dies in Bildunterschriften und Kapitel. Erscheint nie als eigene Seite.`)
};

const ja_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIがこれをキャプションや章に織り込みます。単独のページとして表示されることはありません。`)
};

const zh_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI将把这些信息融入说明和章节中。绝不会作为独立页面出现。`)
};

const ar_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يدمج الذكاء الاصطناعي هذا في التسميات التوضيحية والفصول. لا يظهر أبدًا كصفحة مستقلة.`)
};

const id_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI menenun ini ke dalam keterangan dan bab. Tidak akan muncul sebagai halaman tersendiri.`)
};

const it_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA intreccia queste informazioni nelle didascalie e nei capitoli. Non appare mai come pagina a sé stante.`)
};

const ru_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ вплетает это в подписи и главы. Никогда не появляется как отдельная страница.`)
};

const pt_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA insere isto nas legendas e capítulos. Nunca aparece como uma página própria.`)
};

const ko_the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {(inputs: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 이 정보를 캡션과 챕터에 녹여냅니다. 단독 페이지로 표시되지 않습니다.`)
};

/**
* | output |
* | --- |
* | "The AI weaves this into captions and chapters. Never appears as its own page." |
*
* @param {The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_ai_weaves_this_into_captions_and_chapters_it_n = /** @type {((inputs?: The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_Ai_Weaves_This_Into_Captions_And_Chapters_It_NInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "es") return es_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "fr") return fr_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "de") return de_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "ja") return ja_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "zh") return zh_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "ar") return ar_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "id") return id_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "it") return it_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "ru") return ru_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	if (locale === "pt") return pt_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
	return ko_the_ai_weaves_this_into_captions_and_chapters_it_n(inputs)
});